export default __webpack_public_path__ + "static/media/powered-by.219b277f.svg";